export function resolveGlobalVessel(params, stored) {
    const complete = (accountId, objectCode) => typeof accountId === 'string' && accountId.trim()
        && typeof objectCode === 'string' && objectCode.trim();
    const fromUrl = [params.get('KodeCabang'), params.get('ShipCode')];
    const fromStorage = [stored?.KodeCabang, stored?.ShipCode];
    const pair = complete(...fromUrl) ? fromUrl : complete(...fromStorage) ? fromStorage : null;
    // Hidden setup accounts must not reappear through an old URL or stored selection.
    if (pair?.[0].trim().toUpperCase() === 'SINERGI') return null;
    return pair ? { accountId: pair[0], objectCode: pair[1], key: JSON.stringify(pair) } : null;
}
